var map = {
	"./PXL_20260508_064755837.jpg": 4265,
	"./PXL_20260508_065007787.jpg": 776,
	"./PXL_20260508_065014676.jpg": 1205,
	"./PXL_20260508_070613117.jpg": 7828,
	"./PXL_20260508_071336338.jpg": 4044
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2068;